module.exports = __webpack_public_path__ + "static/header-c6f9fa9b8a9d7da606467266fba71044.jpg";